import React from 'react'

const Separator = props => {
    return (
        <div className="separator">
            <hr className={`separator-${props.data.color}`} />
        </div>
    )
}

export { Separator }


// WEBPACK FOOTER //
// ./src/components/sections/Separator.js